<script setup lang="ts">
import AlarmListingHeader from '@/components/Alarms/Header/AlarmListingHeader.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import DataTableTwo from '@/components/Alarms/Body/DataTables/DataTable.vue'
import AlarmListingSearchBar from '@/components/Alarms/Header/AlarmListingSearchBar.vue'
import { useAlarmStore } from '@/store/alarm'
import { computed } from 'vue'

const alarmStore = useAlarmStore()

const isIndividual = computed(() => alarmStore.lastSearchAlarmScope === 'individual')
</script>

<template>
  <DefaultLayout>
    <div class="min-w-0 w-full max-w-full">
      <div class="flex min-w-0 w-full flex-col p-6 lg:px-8">
        <AlarmListingHeader />
        <AlarmListingSearchBar />
      </div>

      <div class="flex min-w-0 flex-col p-6 lg:px-8">
        <DataTableTwo
          :scope-filter="isIndividual ? 'individual' : 'group'"
          :classified-filter="alarmStore.currentClassificationStatusFilter" />
      </div>
    </div>
  </DefaultLayout>
</template>
